// extracted by mini-css-extract-plugin
module.exports = {"tag":"Odds_tag__2_U0D","bg-disable":"Odds_bg-disable__1COBC","small":"Odds_small__2Kc4H"};